<div (click)="snackBar.dismiss()">
  <app-spinner size="20px" color="white"></app-spinner>
  <span>{{ data.message }}</span>
</div>
